enum TitleSearchStatusEnum {
    Completed = 'COMPLETED',
    NotStarted = 'NOT_STARTED',
    Ordered = 'ORDERED',
    Searched = 'SEARCHED',
}

export default TitleSearchStatusEnum;
